import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Card, ListGroup, Badge, Button, Container } from "react-bootstrap";
import { formatRupiah } from "../utils/formatRupiah";
import "../css/DetailReservation.css";
import { useTranslation } from "react-i18next";

function DetailReservation() {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const { reservation } = location.state || {};

  useEffect(() => {}, [i18n.language, t]);

  if (!reservation) {
    return (
      <div className="text-center my-5">
        <h4>Booking data not found</h4>
        <Button variant="primary" onClick={() => navigate("/dashboard")}>
          Back to Dashboard
        </Button>
      </div>
    );
  }

  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";
    return new Date(dateStr).toLocaleDateString("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const getStatusVariant = (status) => {
    const statusColors = {
      pending: "warning",
      confirmed: "primary",
      checked_in: "success",
      completed: "secondary",
      cancelled: "danger",
      no_show: "dark",
    };
    return statusColors[status] || "info";
  };

  return (
    <Container className="mt-4 detail-container">
      <Button
        variant="outline-secondary"
        onClick={() => navigate(-1)}
        className="mb-3"
      >
        &larr; {t("back")}
      </Button>

      <Card className="shadow-lg rounded detail-card">
        <Card.Body>
          <Card.Title className="text-primary text-center mb-3">
            {t("bookingReference")} :{" "}
            {reservation.booking_reference || "No Reference"}
          </Card.Title>

          <ListGroup variant="flush">
            <ListGroup.Item>
              <strong>Status:</strong>{" "}
              <Badge
                bg={getStatusVariant(reservation.status)}
                className="px-3 py-2"
              >
                {reservation.status.toUpperCase()}
              </Badge>
            </ListGroup.Item>

            <ListGroup.Item>
              <strong>{t("roomType")}:</strong>{" "}
              {reservation.room_type || "Not specified"}
            </ListGroup.Item>

            <ListGroup.Item>
              <strong>Check-in:</strong> {formatDate(reservation.check_in_date)}
            </ListGroup.Item>

            <ListGroup.Item>
              <strong>Check-out:</strong>{" "}
              {formatDate(reservation.check_out_date)}
            </ListGroup.Item>

            <ListGroup.Item>
              <strong>Total Payment:</strong>
              {formatRupiah(reservation.total_price)}
            </ListGroup.Item>
          </ListGroup>
        </Card.Body>
      </Card>
    </Container>
  );
}

export default DetailReservation;
